import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface TabStatus {
    tabGroup: string,
    openTab: string
};

// Define the type for our state store entry
type TabsState = {
    tabGroups: TabStatus[]
}

// Define the initial state for our state store entry
const initialState: TabsState = {
    tabGroups: []
}

// Create a slice to hold all our reducers
const tabsSlice = createSlice({
    name: "tabs",
    initialState: initialState,
    reducers: {
        setOpenTab: (state, action: PayloadAction<TabStatus>) => {
            const entry = state.tabGroups.find(group => group.tabGroup === action.payload.tabGroup);

            if (entry)
                entry.openTab = action.payload.openTab;
            else
                state.tabGroups.push(action.payload);
        }
    }
})

export const {
    setOpenTab
} = tabsSlice.actions

// We have to export the reducer as this is added to the state store
export default tabsSlice.reducer